import { LaunchDarklyService } from './launchDarkly.service';

export function initWithLaunchDarkly(launchDarklyService: LaunchDarklyService) {
  return async () => {
    await launchDarklyService.initialize();
    return Promise.resolve();
  };
}
